module.exports = __webpack_public_path__ + "img/1551260249.e369c5a9.jpg";